export default __webpack_public_path__ + "static/media/js.a46dd469.png";